import RequestServiceFormFieldType from './RequestServiceFormFieldType';

export default {
    [RequestServiceFormFieldType.TEXT]: 'Текст',
    [RequestServiceFormFieldType.NUMBER]: 'Число',
    [RequestServiceFormFieldType.LINK]: 'Ссылка',
    [RequestServiceFormFieldType.FILE]: 'Приложение (файл)',
    [RequestServiceFormFieldType.SELECT]: 'Селектор',
    [RequestServiceFormFieldType.MULTISELECT]: 'Мультиселектор',
};
